<template>
  <div>
    <div v-if="Cargando">
      <zingchart ref="chart" :data="chartData"  />
    </div>
    <div v-if="!Cargando"><br>
      <div class="col-md-2"></div>
        <div class="col-md-8">
          <img src="@/assets/img/warning.png" width="200px" height="200px" style="opacity: 0.5">
          Los datos del año seleccionado no se encuentran disponibles.
        </div>
      <div class="col-md-2"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    top: {
      type: Number,
      default: 10,
    },
    title: {
      type: String,
    },
    total: {
      type: Number,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    series: {
      type: Array,
      default: () => [],
    },
    legend: {
      type: Array,
      default: () => [],
    },
    tipGraf: {
      type: String,
    },
  },
  mounted() {
    console.clear();
  },
  computed: {
    chartData() {
      console.clear();
      return {
        type: 'pie',
        title: {
          text: '',
          align: 'right',
          fontColor: '#616161',
        },
        legend: {
          text: '%t<br>',
          borderWidth: '0px',
          header: {
            align: 'right',
            bold: true,
            fontColor: '#616161',
            fontSize: '13px',
          },
          footer: !isNaN(this.total)
            ? {
                text: 'Total: ' + Math.round(this.total).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
                align: 'right',
                bold: true,
                fontColor: '#616161',
                fontSize: '13px',
                padding: '10px',
                borderRadius: '3px',
                backgroundColor: '#2196f3',
                fontColor: '#fff',
                width: '175px',
              }
            : undefined,
          item: {
            align: 'right',
            padding: '10px',
            borderRadius: '3px',
            backgroundColor: '#2196f3',
            fontColor: '#fff',
            width: '225px',
            text: '%t<br><b>%v</b>',
          },
          itemOff: {
            alpha: 0.7,
            fontColor: '#616161',
            lineWidth: '2px',
            textAlpha: 1,
            textDecoration: 'line-through',
          },
          markerOff: {
            alpha: 0.2,
          },
          toggleAction: 'remove',
          verticalAlign: 'middle',
        },
        plot: {
          valueBox: {
            decimals: 2,
            placement: 'out',
          },
          animation: {
            effect: 'ANIMATION_EXPAND_VERTICAL',
            method: 'ANIMATION_BACK_EASE_OUT',
            onLegendToggle: false,
            sequence: 'ANIMATION_BY_PLOT',
          },
          decimals: 0,
          detach: false,
          refAngle: 270,
          thousandsSeparator: '.',
        },
        scale: {
          sizeFactor: 0.75,
        },
        tooltip: {
          text: '%t<br>%v',
          align: 'right',
          bold: true,
          borderRadius: '3px',
          fontColor: '#fff',
          offsetR: 10,
          placement: 'node:out',
        },
        series: this.series,
      };
    },
    Cargando() {
      this.loading = true;
      if (Array.isArray(this.series) && this.series.length) {
        this.loading = true;
      } else {
        this.loading = false;
      }
      return this.loading;
      console.clear();
    },
  },
  data() {
    return {
      t: '',
      loading: true,
      c: [],
      s: [],
      seriesaux: [],
    };
  },
};
</script>
